export enum DOCUMENT_TYPE {
    GUARD_LICENSE = 'guard_license',
    ID_CARD = 'id_card',
    FIRST_AID = 'first_aid',
    CARRY_PERMIT = 'carry_permit'
}
